class SubscriptionProduct {
  constructor(data) {
      this.data = data;
      this.sizeOption = document.querySelectorAll('input[name="sizeOption"]');
      this.planOption = document.querySelectorAll('input[name="planOption"]');
      this.subscriptionConditions = document.querySelector("#subscriptionConditions");
      this.sellingPlanInput = document.querySelector("[name=selling_plan]");
      this.idInput = document.querySelector("[name=id]");
  }

  getSelectedSize() {
      const selectedSize = document.querySelector('input[name="sizeOption"]:checked');
      return selectedSize ? selectedSize.value : null;
  }

  getSelectedPlanHandle() {
      const selectedPlan = document.querySelector('input[name="planOption"]:checked');
      return selectedPlan ? selectedPlan.dataset.productHandle : null;
  }

  getVariantData(key) {
      const selectedSize = this.getSelectedSize();
      const handle = this.getSelectedPlanHandle();
      const selProd = this.data[handle];
      const variants = selProd["variants"];
      for (let i = 0; i < variants.length; i++) {
          if (variants[i]["option1"].toUpperCase() === selectedSize.toUpperCase()) {
              return variants[i][key];
          }
      }
      return null;
  }

  getVariantID() {
      return this.getVariantData("id");
  }

  getSKU() {
      return this.getVariantData("sku");
  }

  getPlanID() {
      const handle = this.getSelectedPlanHandle();
      const {
          selling_plans
      } = this.data[handle]?.selling_plan_groups?.[0] || {};
      const planID = selling_plans?.[0]?.id;
      return planID || null;
  }

  getProductHandle() {
      return this.getSelectedPlanHandle();
  }

  updateHistoryState() {
      if (!history.replaceState) {
          return;
      }
      const variantID = this.getVariantID();
      const planID = this.getPlanID();
      const newUrl = `${window.location.protocol}//${window.location.host}${window.location.pathname}?variant=${variantID}&selling_plan=${planID}`;
      window.history.replaceState({
          path: newUrl
      }, '', newUrl);
  }

  changeSubscriptionCondition(productObject) {
      let conditions = document.querySelector("#subscriptionConditions"),
          planID = parseInt(productObject.dataset.sellingPlanId),
          price = (productObject.dataset.planPrice / 100).toLocaleString("en-US", {
              style: "currency",
              currency: "USD"
          }),
          nextYear = new Date().getFullYear() + 1,
          monthlyPrice = document.querySelector(".monthlyPrice");
      switch (planID) {
          case 1262714938:
              conditions.innerHTML = `
      <p>Today, you'll be charged $29.99 for <span class="nextMonth"></span>'s shirt. For US orders, shipping is FREE. <br>Your next payment is on <span class="twoMonths"></span> the end every month after until you cancel.</p>
      `
              monthlyPrice.textContent = (parseFloat(price.replace("$", ""))).toLocaleString("en-US", {
                  style: "currency",
                  currency: "USD"
              });
              break;
          case 814186554:
              conditions.innerHTML = `
      <p>Today, you'll be charged ${price} for 6 months of the Afterlife Subscription. Your subscription will renew at the end of <span class="sixMonths"></span>. Cancel at any time. <strong>Pre-paid subscriptions are non-refundable.</strong></p>
      `
              monthlyPrice.textContent = (parseFloat(price.replace("$", "")) / 6).toLocaleString("en-US", {
                  style: "currency",
                  currency: "USD"
              });
              break;
          case 814153786:
              // code block
              conditions.innerHTML = `
      <p>Today, you'll be charged ${price} for 12 months of the Afterlife Subscription. Your subscription will renew at the end of <span class="twelveMonths"></span>, ${nextYear}. Cancel at any time. <strong>Pre-paid subscriptions are non-refundable.</strong></p>
      `
              monthlyPrice.textContent = (parseFloat(price.replace("$", "")) / 12).toLocaleString("en-US", {
                  style: "currency",
                  currency: "USD"
              });
              break;
          default:
              // code block
      }
  }

  handleChange() {
      this.updateHistoryState();
      this.sellingPlanInput.value = this.getPlanID();
      this.idInput.value = this.getVariantID();
      this.idInput.dataset.sku = this.getSKU();
      this.changeSubscriptionCondition(event.target);
      changeDates();
  }
}

const productData = JSON.parse(document.querySelector('[data-multiple-product-json]').innerHTML);
const product = new SubscriptionProduct(productData);

window.addEventListener("change", function(event) {
  if (event.target.classList.contains("SizeSwatch__Radio") || event.target.classList.contains("PlanSwatchList")) {
      product.handleChange();
  }
});


window.addEventListener('load', () => {
  const params = new URL(document.location).searchParams;
  const variantParameter = params.get("variant");
  if (variantParameter !== null) {
      for (const product of Object.values(productData)) {
          const variant = product.variants.find(v => v.id === parseInt(variantParameter));
          if (variant) {
              const {
                  option1: selectedSize,
                  selling_plan_allocations: allocations
              } = variant;
              const sellingPlanID = parseInt(allocations?.[0]?.selling_plan_id);
              if (selectedSize && sellingPlanID) {
                  const planSwatchList = document.querySelector(`.PlanSwatchList input[value="${sellingPlanID}"]`);
                  const sizeSwatchList = document.querySelector(`.SizeSwatchList input[value="${selectedSize}"]`);
                  if (planSwatchList && sizeSwatchList) {
                      planSwatchList.click();
                      sizeSwatchList.click();
                  }
              }
              break;
          }
      }
  }
});




// Old stuff


//faq toggle functionality
const faq = document.querySelectorAll(".accordion");

function toggleFAQ() {
  for (let i = 0; i < faq.length; i++) {
      faq[i].addEventListener("click", function(e) {
          e.target.parentElement.nextElementSibling.classList.toggle("showAnswer");
          e.target.parentElement.parentElement.querySelector(".q").classList.toggle('minus');
      });
  }
}

//get time from now

function timeFromNow(time) {
  const unixTime = parseInt(time);
  if (!unixTime || isNaN(unixTime)) {
      return;
  }
  const now = Date.now() / 1000;
  const difference = unixTime - now;
  const tfn = {
      when: difference <= 0 ? 'past' : 'future',
      days: (difference / 86400) | 0,
      hours: ((difference / 3600) | 0) % 24,
      minutes: ((difference / 60) | 0) % 60,
      seconds: (difference | 0) % 60,
  };
  return tfn;
}


function getNextTimestamp() {
  // Get the current date and time in UTC
  let now = new Date();

  // Check the to see if the cutoff has passed
  const year = now.getUTCFullYear();
  const month = now.getUTCMonth();
  const nextMonth = new Date(year, now.getDate() > 2 ? month + 1 : month, 3);

  // Calculate the UTC offset for Eastern Standard Time
  const isDST = () => {

      // Get the year of the current date
      const year = now.getUTCFullYear();

      // Calculate the date for the second Sunday in March
      const marchDate = new Date(Date.UTC(year, 2, 1));
      marchDate.setUTCDate(marchDate.getUTCDate() + ((7 - marchDate.getUTCDay() + 1) % 7) + 7);

      // Calculate the date for the first Sunday in November
      const novemberDate = new Date(Date.UTC(year, 10, 1));
      novemberDate.setUTCDate(novemberDate.getUTCDate() + ((7 - novemberDate.getUTCDay() + 1) % 7));

      // Determine whether the current date is within the daylight saving time period
      return now.getTime() >= marchDate.getTime() && now.getTime() < novemberDate.getTime();
  };

  const utcOffset = isDST() ? 3 : 4;

  // Set the time to 12:00 AM EST (UTC-5 or UTC-4 during daylight saving time)
  nextMonth.setUTCHours(0);
  nextMonth.setUTCMinutes(0);
  nextMonth.setUTCSeconds(0);
  nextMonth.setUTCMilliseconds(0);
  nextMonth.setHours(nextMonth.getHours() + utcOffset);

  // Convert the date to a Unix timestamp and return it
  return Math.floor(nextMonth.getTime() / 1000);
}


function endOfMonthCtdwn() {
  const currentTime = Date.now() / 1000;
  const nextDeadline = getNextTimestamp();
  if (nextDeadline) {
      setInterval(() => {
          const time = timeFromNow(nextDeadline);
          const el = document.querySelectorAll(".end-of-month-countdown > div > span");
          [time.days, time.hours, time.minutes, time.seconds].forEach((val, i) => {
              el[i].textContent = String(val).padStart(2, '0');
          });
      }, 1000);
      document.querySelector(".end-of-month-countdown").style.display = "flex";
  }
}


function getMonths(monthIndex) {
  const monthNames = [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December"
  ];

  // Subtract 1 from the monthIndex to account for zero-based indexing
  return monthNames[monthIndex - 1];
}

function changeDates() {
  const now = new Date();
  const month = now.getMonth() + 1;
  const currentMonth = getMonths(month);
  const nextMonth = getMonths(month + 1, true) || 'Jan';
  const twoMonths = getMonths(month + 2);
  const sixMonths = getMonths(month + 6);
  const twelveMonths = getMonths(month + 1);
  const elements = {
      '.thisMonth': currentMonth + ' ',
      '.nextMonth': nextMonth,
      '.twoMonths': twoMonths,
      '.sixMonths': sixMonths,
      '.twelveMonths': twelveMonths,
  };
  Object.entries(elements).forEach(([selector, text]) => {
      document.querySelectorAll(selector).forEach((element) => {
          element.textContent = text;
      });
  });
}


window.addEventListener('load', function() {
  toggleFAQ();
  endOfMonthCtdwn();
  changeDates();
});

console.log("TESTI");
